import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FiXCircle } from 'react-icons/fi';

import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from '@material-ui/core';
import { CloseRounded as CloseIcon } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';

const modalErrorStyles = {
  root: {
    '& .MuiPaper-root': {
      borderRadius: '6px',
    },
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    '& svg': {
      marginBottom: '16px',
    },
  },
  title: {
    margin: 0,
    padding: '16px',
    backgroundColor: '#D12E2E',
    color: '#fff',
    '& h6': {
      fontSize: '21px',
    },
    display: 'flex',
    justifyContent: 'space-between',
  },
  closeButton: {
    color: '#fff',
    padding: 0,
  },
};

class ModalError extends Component {
  state = {
    open: true,
  };

  closeModal = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, title, children } = this.props;
    const { open } = this.state;

    return (
      <Dialog open={open} maxWidth="sm" className={classes.root}>
        <DialogTitle disableTypography className={classes.title}>
          <Typography variant="h6">{title}</Typography>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => this.closeModal()}
            disableRipple
          >
            <CloseIcon fontSize="large" />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box className={classes.modalBody}>
            <FiXCircle size={50} color="#D12E2E" />
            <Typography component="div">
              <Box fontSize={16}>Ops, ocorreu um erro inesperado.</Box>
              <br />
              <Box fontSize={16}>
                Caso o erro persista, por favor, entre em contato pelo{' '}
                <strong>{process.env.REACT_APP_CENTRAL_PHONE_NUMBER}</strong>
              </Box>
            </Typography>
          </Box>
          {children}
        </DialogContent>
      </Dialog>
    );
  }
}

ModalError.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default withStyles(modalErrorStyles)(ModalError);
